import { useFormikContext } from 'formik';
import { CommNoteFormType } from './CommunicationNotePage';
import { useMemo } from 'react';
import { NoteSection } from '../components/NoteSection';
import { Box } from '@mui/material';
import { ServerForm } from '@uplift/ui-v2';
import { SessionFormField, SessionFormFieldsGroup } from '@uplift/api';

export type RiskSectionProps = {
  fields: (SessionFormField | SessionFormFieldsGroup)[];
};

export const RiskSection: React.VFC<RiskSectionProps> = ({ fields }) => {
  const formik = useFormikContext<CommNoteFormType>();

  const riskDisabled = useMemo(() => {
    const participants = formik.values.comm['contact_participants'];

    if (!participants) {
      return false;
    }

    return participants !== 'client';
  }, [ formik.values.comm ]);

  return (
    <NoteSection title="Risk Assessment" disabled={riskDisabled}>
      <Box pb={formik.values.risk['deny_all_areas_of_risk'] === false ? 0 : 3}>
        <ServerForm
          fields={fields}
          namespace="risk"
          disabled={riskDisabled}
        />
      </Box>
    </NoteSection>
  );
};
